import { createDeferred, Deferred } from "./promiseHelpers";

export function createPendingRequests() {
  const requests = new Map<string, Deferred<unknown>>();

  function take(correlationId: string) {
    const request = requests.get(correlationId);
    requests.delete(correlationId);
    return request;
  }

  return {
    add(correlationId: string) {
      const deferred = createDeferred<unknown>();
      requests.set(correlationId, deferred);
      return deferred.promise;
    },
    delete(correlationId: string) {
      requests.delete(correlationId);
    },
    reject(correlationId: string, error: Error) {
      take(correlationId)?.reject(error);
    },
    rejectAll(error: Error) {
      requests.forEach((request) => request.reject(error));
      requests.clear();
    },
    resolve(correlationId: string, value: unknown) {
      take(correlationId)?.resolve(value);
    },
  };
}
